import { Routes } from '@angular/router';
import { HomeComponent } from './page/home/home.component';
import { JobComponent } from './page/job/job.component';
import { AboutUsComponent } from './page/about-us/about-us.component';
import { ContactUsComponent } from './page/contact-us/contact-us.component';
import { DetailsJobComponent } from './page/details-job/details-job.component';
import { AdminComponent } from './core/admin/admin.component';
import { HomeAdminComponent } from './page/admin/home-admin/home-admin.component';
import { AreaComponent } from './page/admin/area/area.component';
import { RegisterComponent } from './page/register/register.component';
import { LoginComponent } from './page/login/login.component';
import { AuthGuard } from './core/guard/auth.guard';
import { UserCompanyComponent } from './page/user-company/user-company.component';
import { UserCompanyDetailsComponent } from './page/user-company-details/user-company-details.component';
import { UserCompanyLayoutComponent } from './core/layout/user-company-layout/user-company-layout.component';
import { JobOffersDetailsComponent } from './page/job-offers-details/job-offers-details.component';
import { JobOffersComponent } from './page/job-offers/job-offers.component';
import { CreateJobOfferComponent } from './page/create-job-offer/create-job-offer.component';
import { UserCompanyViewComponent } from './page/user-company-view/user-company-view.component';
import { UserMyJobsComponent } from './page/user-my-jobs/user-my-jobs.component';
import { LayoutComponent } from './core/layout/main-layout/layout.component';
import { JobOfferPostulantDetailComponent } from './page/job-offer-postulant-detail/job-offer-postulant-detail.component';
import { AuthUserGuard } from './core/guard/auth-user.guard';
import { UserCompanyEditComponent } from './page/user-company-edit/user-company-edit.component';
import { ConfirmationComponent } from './page/confirmation/confirmation.component';
import { ProfileLayoutComponent } from './core/layout/profile-layout/profile-layout.component';
import { ProfileComponent } from './page/profile/profile.component';
import { ProfileExperinceComponent } from './page/profile-experince/profile-experince.component';
import { PackagesComponent } from './page/packages/packages.component';
import { CompanyPackageComponent } from './page/company-package/company-package.component';
import { LoginAdminComponent } from './page/admin/login-admin/login-admin.component';
import { PackageAdminComponent } from './page/admin/package-admin/package-admin.component';
import { PackageCompanyAdminComponent } from './page/admin/package-company-admin/package-company-admin.component';
import { AuthAdminGuard } from './core/guard/auth-admin.guard';
import { LoginCodideepComponent } from './page/login-codideep/login-codideep.component';
import { JobTitleComponent } from './page/admin/job-title/job-title.component';
import { JobTypeComponent } from './page/admin/job-type/job-type.component';
import { BussinesLineComponent } from './page/admin/bussines-line/bussines-line.component';
import { ProfessionsComponent } from './page/admin/professions/professions.component';
import { CompanyDetailComponent } from './page/company-detail/company-detail.component';
import { CompaniesComponent } from './page/companies/companies.component';
import { PricingComponent } from './page/pricing/pricing.component';
import { ConfirmationGuard } from './core/guard/confirmation.guard';
import { UserCompanyMembersComponent } from '@pages/user-company-members/user-company-members.component';

export const routes: Routes = [
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'login-c',
    component: LoginCodideepComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'confirmation',
    component: ConfirmationComponent,
    canActivate: [AuthGuard, ConfirmationGuard],
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'jobs', component: JobComponent },
      { path: 'about-us', component: AboutUsComponent },
      { path: 'pricing', component: PricingComponent },
      { path: 'contact-us', component: ContactUsComponent },
      { path: 'companies', component: CompaniesComponent },
      { path: 'companies/:id', component: CompanyDetailComponent },
      { path: 'job/:id', component: DetailsJobComponent },
      {
        path: 'user/detail',
        component: ProfileLayoutComponent,
        canActivate: [AuthUserGuard],
        children: [
          { path: '', component: ProfileComponent },
          { path: 'experience', component: ProfileExperinceComponent },
        ],
      },
      {
        path: 'job-postulant/:id',
        component: JobOfferPostulantDetailComponent,
        canActivate: [AuthUserGuard],
      },
      {
        path: 'user/company',
        component: UserCompanyComponent,
        canActivate: [AuthUserGuard],
      },
      {
        path: 'user/company/:id',
        component: UserCompanyLayoutComponent,
        canActivate: [AuthUserGuard],
        children: [
          { path: '', component: UserCompanyDetailsComponent },
          { path: 'edit', component: UserCompanyEditComponent },
          { path: 'job-offers', component: JobOffersComponent },
          { path: 'my-package', component: CompanyPackageComponent },
          { path: 'packages', component: PackagesComponent },
          {
            path: 'job-offer-details/:id',
            component: JobOffersDetailsComponent,
          },
          { path: 'job-offer/create', component: CreateJobOfferComponent },
          { path: 'view/:id', component: UserCompanyViewComponent },
          { path: 'members', component: UserCompanyMembersComponent },
          { path: '', redirectTo: 'info', pathMatch: 'full' },
        ],
      },
      {
        path: 'my-jobs',
        component: UserMyJobsComponent,
        canActivate: [AuthUserGuard],
      },
    ],
  },
  {
    path: 'admin/login',
    component: LoginAdminComponent,
  },
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AuthAdminGuard],
    children: [
      { path: '', component: HomeAdminComponent },
      { path: 'package', component: PackageAdminComponent },
      { path: 'area', component: AreaComponent },
      { path: 'job-title', component: JobTitleComponent },
      { path: 'job-type', component: JobTypeComponent },
      { path: 'business-line', component: BussinesLineComponent },
      { path: 'profession', component: ProfessionsComponent },
      { path: 'package/company/:id', component: PackageCompanyAdminComponent },
    ],
  },
];
